module.exports = __webpack_public_path__ + "img/4-2-4-3-3-preview-ito-e.461fd00a.jpg";